<template>
  <div class="col-md-1 mainLogoContainer">
    <a class="navbar-brand" href data-test="headerNavTabLink1" id="headerNavTabLink1">
      <div class="order-0 order-2 order-xl-1 brand-img-cont wp_headerItemsAlign">
        <div id="wp_homepage_headerLogo" class="navbrand">
          <a
            href
            @click.prevent="homeRedirection"
            id="logo-container-img-link"
            data-test="logoContainerLink1"
          >
            <img
              :src="logo.headerLogo"
              :alt="logo.headerLogoAltText"
              id="logoContainerImg1"
              data-test="logoContainerImg1"
            />
          </a>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import siteInfo from '@/assets/cms_templates_repo/site-config.json'
export default {
	data () {
		return {
			logo: siteInfo.logo
		}
	},
	methods: {
		homeRedirection () {
			if (
				document.getElementById('wp_CategoryNav') &&
        document.getElementById('wp_CategoryNav').style
			) {
				document.getElementById('wp_CategoryNav').style.top = '59px'
			}
			this.$router.push({ name: 'Home' })
		}
	}
}
</script>
